"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MCreateFixedAsset = class MCreateFixedAsset extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    assetType;
    onAsset_type(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("assetType");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('CreateFixedAsset', {
            asset_type: this.assetType,
            waste_bin: {
                bin_type: null,
                bin_number: null,
                capacity: {
                    amount: null,
                    unit: 'liter'
                }
            }
        });
    }
    fixedAssetTypes;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formName', 'formId', 'item', 'fixedAssetTypes', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formName: "rental",
                formId: null,
                item: null,
                fixedAssetTypes: [{
                        id: "general",
                        name: this.$fn.pgettext("FixedAssetTypes", "General"),
                    },
                    {
                        id: "waste_bin",
                        name: this.$fn.pgettext("FixedAssetTypes", "Waste Bin"),
                    },
                ],
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Create Fixed Asset"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_1872_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_1878_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_navigate_1880_getActionArgs($event) {
        return {
            location: {
                name: "app.fixedAsset",
                params: {
                    id: $event.data.response.data.id,
                },
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_1882_getActionArgs($event) {
        return {
            grid: "fixedAssets",
        };
    }
    async act_1040167445267876_reloadSlickgrid_1884_getActionArgs($event) {
        return {
            grid: "wasteBins",
        };
    }
    async act_1040167445267876_request_1876_getActionArgs($event) {
        return {
            operation: "create_fixed_asset",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_1872 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_1872_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_1871 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_1872,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_1871],
        });
        const act_2248226175642056_closeModal_1874 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_1873 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_1874,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_1873],
        });
        const act_1040167445267876_closeModal_1878 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_1878_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1877 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_1878,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_navigate_1880 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1040167445267876_navigate_1880_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1879 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_navigate_1880,
            event: "success",
            displayName: "navigate",
        });
        const act_1040167445267876_reloadSlickgrid_1882 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_1882_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1881 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_1882,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_reloadSlickgrid_1884 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_1884_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1883 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_1884,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_request_1876 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_1876_getActionArgs,
            displayName: "create",
            events: [evh_1040167445267876_success_1877, evh_1040167445267876_success_1879, evh_1040167445267876_success_1881, evh_1040167445267876_success_1883],
        });
        const evh_1040167445267876_submit_1875 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_1876,
            event: "submit",
            displayName: "create",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_1875],
        });
        const act_1419464017721962_closeComponent_1886 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_1885 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_1886,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_1885],
        });
        return {
            act_7315092382398562_closeModal_1872,
            evh_7315092382398562_close_1871,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_1874,
            evh_2248226175642056_close_1873,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_1878,
            evh_1040167445267876_success_1877,
            act_1040167445267876_navigate_1880,
            evh_1040167445267876_success_1879,
            act_1040167445267876_reloadSlickgrid_1882,
            evh_1040167445267876_success_1881,
            act_1040167445267876_reloadSlickgrid_1884,
            evh_1040167445267876_success_1883,
            act_1040167445267876_request_1876,
            evh_1040167445267876_submit_1875,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_1886,
            evh_1419464017721962_clickPreventStop_1885,
            evh_1419464017721962_clickPreventStop,
            create: act_1040167445267876_request_1876,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "general",
    }),
    __metadata("design:type", String)
], MCreateFixedAsset.prototype, "assetType", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('assetType'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MCreateFixedAsset.prototype, "onAsset_type", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], MCreateFixedAsset.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MCreateFixedAsset.prototype, "onSize", null);
MCreateFixedAsset = __decorate([
    (0, vue_property_decorator_1.Component)()
], MCreateFixedAsset);
exports.default = MCreateFixedAsset;
vue_property_decorator_1.Vue.component("MCreateFixedAsset", MCreateFixedAsset);
